// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"headline_wrapper__2L_FC"};